import React, { PureComponent } from 'react'
import { Redirect } from 'react-router-dom'
import { Icon, message } from 'antd'
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import { request } from '../../utils/api';
import qs from 'querystring'

class ConfirmConta extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            success: false,
            loading: true,
            fillBackground: false
        }
    }

    async componentDidMount() {
        try {
            const query = qs.parse(this.props.location.search.replace('?', ''))
            const hash = query.q
            const userid = query.u
            const { code, message: errMessage } = await request('users/confirm-email', 'PUT', {
                id: userid,
                hash
            })
            if (code === 200) {
                this.handleSuccess()
            } else {
                this.handleError(errMessage)
            }
        } catch(e) {
            // console.log(e)
            this.handleError()
        }
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    handleSuccess = () => {
        message.success('Parabéns! Sua conta foi confirmada!')
        this.setState({
            success: true
        })
    }

    handleError = (errMessage = 'Ops! Não conseguimos confirmar sua conta!') => {
        message.error(errMessage)
        this.setState({
            loading: false
        })
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    render() {
        const { success, loading } = this.state
        return (
            <div id="sectionPass">
                <Navbar fillBackground={this.state.fillBackground} />
                <div className="signupWrapper">
                    <div className="signupHeader" style={{ height: 190 }}>
                        <div>
                            <h2 className="title text-white text-center">Verificação de Conta</h2>
                        </div>
                    </div>
                </div>
                {success ? (
                    <Redirect to="/minhaconta" />
                ) : (
                    <div style={{ alignItems: 'center', display: 'flex', maxWidth: 960, margin: 'auto', justifyContent: 'center' }}>
                        <div style={{ display: 'flex', flex: 1, fontSize: '6em', justifyContent: 'center', alignItems: 'center' }}>
                            <Icon type={loading ? 'loading' : 'close'} />
                        </div>
                        <div style={{ flex: 2 }}>
                            <h2 className="text-white">Aguarde!</h2>
                            <p className="text-white">Estamos validando sua conta. Você será redirecionado em breve!</p>
                        </div>
                    </div>
                )}
                <Footer />
            </div>
        )
    }
}

export default ConfirmConta